import { useEffect } from 'react';
import { useCartContext } from '@/cart/context';
import EVENTS from '@/utils/Constants/Events';

export default () => {
  const [, { setCart, setCartLoading, unsetCartLoading }] = useCartContext();
  useEffect(() => {
    setCartLoading();
    DLG.EVE.emit(EVENTS.CART.GET);
    DLG.EVE.on(EVENTS.CART.REFRESH, cart => {
      setCart(cart);
      unsetCartLoading();
    });
    return () => DLG.EVE.off(EVENTS.CART.REFRESH);
  }, []);
};
